import toastACI from "components/toastACI";
import useStorage from "hooks/useStorage";
import client from "./client";
import commonHelper from "./commonHelper";

export const getIsLastSubtest = () => {
  const { getItem } = useStorage();
  const listSubtest = getItem("listSubtest");
  const total = (listSubtest || [])?.length;
  const finished = (listSubtest || [])?.filter((item) => item?.isFinished)?.length;

  return finished + 1 === total;
};

export const autoSaveAnswer = async (currDataExam) => {
  const { getItem } = useStorage();

  const savedQuestion = getItem("savedQuestion");
  const participant = getItem("participant");
  const dataExamLocal = getItem("dataExam");
  const subtest = getItem("subtest");
  const tempDataExam = currDataExam?.questions || dataExamLocal;
  const tempQuestionAccessed = currDataExam?.questionAccessed || savedQuestion?.questionAccessed;

  let finalChoice = [];
  for (let i = 0; i < tempDataExam?.length; i += 1) {
    const choices = tempDataExam?.[i]?.map((item) => {
      let answer = item?.questionAnswer?.toString();

      if (item?.componentType === 11) {
        answer = JSON.parse(item?.questionAnswer || "[]")?.filter(
          (item2) => item2?.status === "finished"
        );
        answer = answer?.length ? JSON.stringify(answer) : "";
      }
      return {
        questionId: item.questionId,
        questionAnswer: answer,
        questionAnswerVideo: item.questionAnswerVideo,
        questionChoice: item.questionChoice,
        answerTime: item.answerTime,
        questionAnswerScore: item.questionAnswerScore,
        questionAspectId: item.questionAspectId,
        componentTypeId: item.componentType,
      };
    });
    finalChoice = [...finalChoice, ...choices];
  }

  const obj = {
    participantName: participant.participantName,
    participantId: participant.participantId,
    projectId: participant.projectId,
    subtestId: subtest.subtestId,
    isTrial: subtest.isTrial,
    subtestDimensionId: subtest?.subtestDimensionId,
    questionAccessed: tempQuestionAccessed || 1,
    questions: [...finalChoice],
  };
  await client.requestAPI({
    endpoint: "api/v1/exam-participants/exam-projects/exam_subtests/submit-temp",
    isAuth: false,
    isSubmit: false,
    method: "POST",
    data: { ...obj },
  });
};

const navigateByCurrentFinishedSubtest = (listSubtest) => {
  const { pathname } = commonHelper.history.location;
  const { setItem, getItem } = useStorage();
  const project = getItem("project");
  const subtest = getItem("subtest");

  let currentSubtestIndex = listSubtest.findIndex((value) => subtest.subtestId === value.subtestId);

  if (currentSubtestIndex === -1) {
    while (listSubtest[currentSubtestIndex + 1]?.isFinished) {
      currentSubtestIndex += 1;
    }
  }

  const isLastSubtest =
    currentSubtestIndex === listSubtest.length - 1 && currentSubtestIndex !== -1;

  if (isLastSubtest) {
    commonHelper.history.navigate("/finishExam");
  } else {
    let nextSubtestIndex = currentSubtestIndex + 1;

    while (nextSubtestIndex < listSubtest.length - 1 && listSubtest[nextSubtestIndex]?.isFinished) {
      nextSubtestIndex += 1;
    }

    if (nextSubtestIndex === listSubtest.length - 1 && listSubtest[nextSubtestIndex]?.isFinished) {
      commonHelper.history.navigate("/finishExam");
      return;
    }

    const nextSubtest = listSubtest[nextSubtestIndex];

    setItem("listSubtest", listSubtest);
    setItem("subtest", nextSubtest);

    if (project?.isProctoring && !commonHelper.isIframe()) {
      commonHelper.history.navigate("/proctoringAmanin", false);
    } else if (pathname.includes("instructionExam")) {
      setItem("savedTimerInstruction", nextSubtest?.subtestInstructionTimer);
      commonHelper.history.navigate(0);
    } else {
      commonHelper.history.navigate("/instructionExam");
    }
  }
};

export const handleStartNextSubtest = async () => {
  const { getItem, removeItem } = useStorage();
  removeItem("savedTimerInstruction");
  removeItem("exam");
  removeItem("savedQuestion");
  removeItem("randomQuestionTemp");
  removeItem("randomAnswerTemp");
  removeItem("savedQuestionServer");

  const participant = getItem("participant");
  const resSubtest = await client.requestAPI({
    endpoint: `api/v1/exam-participants/${participant?.participantId}/exam-projects/${participant?.projectId}/exam-subtests`,
    isAuth: false,
  });

  if (resSubtest?.meta?.status !== "Success") {
    commonHelper.toast.push(
      toastACI({
        type: "error",
        header: "Continue Exam Error",
        message:
          resSubtest?.error?.message || "Please try again! If problem persists, contact helpdesk.",
      }),
      {
        placement: "topEnd",
      }
    );
    commonHelper.history.navigate("/");
  } else if (!resSubtest?.data?.length) {
    commonHelper.history.navigate("/finishExam");
  } else {
    navigateByCurrentFinishedSubtest(resSubtest?.data);
  }
};

export const handleFinishNoQuestion = async (currentSubtest) => {
  const { getItem, removeItem } = useStorage();
  const participant = getItem("participant");
  const subtest = getItem("subtest");
  const { pathname } = commonHelper.history.location;
  const tempSubtest = currentSubtest || subtest;

  const result = await client.requestAPI({
    endpoint: `api/v1/exam-participants/exam-projects/exam_subtests/submit`,
    method: "POST",
    isAuth: false,
    isSubmit: true,
    headers: {
      "X-Encrypted-IP": participant?.ipAddress,
    },
    data: {
      participantName: participant?.participantName,
      participantId: participant?.participantId,
      projectId: participant?.projectId,
      subtestId: tempSubtest?.subtestId,
      isTrial: tempSubtest?.isTrial,
      subtestDimensionId: tempSubtest?.subtestDimensionId,
      locFunction: "Auto Submit FE (Subtest No Questions)",
    },
  });
  if (result?.meta?.status === "Success") {
    removeItem("savedQuestion");
    commonHelper.toast.push(
      toastACI({
        type: "success",
        header: "Exam Info",
        message: "Success submit exam",
      }),
      {
        placement: "topEnd",
      }
    );
    handleStartNextSubtest();
  } else {
    commonHelper.toast.push(
      toastACI({
        type: "error",
        header: "Finish Exam",
        message: result?.error?.message,
      }),
      {
        placement: "topEnd",
      }
    );

    if (pathname.includes("dashboardExam")) commonHelper.navigate("/");
  }
};

export const handleStartSubtest = async (setOpenModalContinue) => {
  const { setItem, getItem, removeItem } = useStorage();
  const participant = getItem("participant");
  const subtest = getItem("subtest");

  const resStart = await client.requestAPI({
    endpoint: `api/v1/exam-participants/exam-projects/exam-subtests/start`,
    method: "POST",
    isAuth: false,
    data: {
      participantName: participant?.participantName,
      participantId: participant?.participantId,
      projectId: participant?.projectId,
      subtestId: subtest?.subtestId,
      isTrial: subtest?.isTrial,
    },
  });
  if (resStart?.meta?.status === "Success") {
    const resQuest = await client.requestAPI({
      endpoint: `api/v1/exam-participants/${participant?.participantId}/exam-projects/${participant?.projectId}/exam-subtests/${subtest?.subtestId}/questions?isTrial=${subtest?.isTrial}`,
      isAuth: false,
    });

    if (resQuest?.meta?.status === "Success") {
      removeItem("savedTimerInstruction");
      removeItem("isStuckInstruction");

      if (resQuest?.data && resQuest?.data.length === 0) {
        handleFinishNoQuestion();
      } else {
        setItem("savedTimerExam", resStart?.subtestStartedOn);
        setItem("exam", resQuest?.data);
        commonHelper.navigate("/questLayoutExam");
      }
    } else {
      commonHelper.toast.push(
        toastACI({
          type: "error",
          header: "Start Exam Error",
          message: resQuest?.error?.message,
        }),
        {
          placement: "topEnd",
        }
      );
      setItem("isStuckInstruction", true);
    }
  } else {
    commonHelper.toast.push(
      toastACI({
        type: "error",
        header: "Start Exam Error",
        message: resStart?.error?.message,
      }),
      {
        placement: "topEnd",
      }
    );

    if (resStart?.error?.message.includes("not the subtest's turn")) {
      setOpenModalContinue(true);
    } else {
      setItem("isStuckInstruction", true);
    }
  }
};

const getTempAnswer = async (participant, startedSubtest, subtestQuestions) => {
  const { setItem, getItem, removeItem } = useStorage();

  const resTemp = await client.requestAPI({
    endpoint: `api/v1/exam-participants/${participant?.participantId}/exam-projects/${participant?.projectId}/exam-subtests/${startedSubtest?.subtestId}/submit-temp`,
    isAuth: false,
  });
  if (resTemp?.meta?.status === "Success") {
    const lastSavedQuestion = getItem("lastSavedQuestion");
    const randomQuestionTemp = getItem("randomQuestionTemp");
    setItem("savedQuestionServer", resTemp?.data);

    const isRandomSubtestMatched =
      startedSubtest?.subtestRandomQuestion &&
      startedSubtest?.subtestId === randomQuestionTemp?.subtestId &&
      startedSubtest?.subtestId === lastSavedQuestion?.subtestId;
    const isNonRandomSubtestMatched =
      !startedSubtest?.subtestRandomQuestion &&
      startedSubtest?.subtestId === lastSavedQuestion?.subtestId;

    if (isRandomSubtestMatched || isNonRandomSubtestMatched) {
      setItem("savedQuestion", {
        subtestId: lastSavedQuestion?.subtestId,
        currentPage: lastSavedQuestion?.currentPage,
        questionAccessed: lastSavedQuestion?.questionAccessed,
        indexPageQuestion: lastSavedQuestion?.indexPageQuestion,
      });
    }
    removeItem("lastSavedQuestion");
  } else {
    commonHelper.toast.push(
      toastACI({
        type: "error",
        header: "Continue Exam Error",
        message: "Failed get saved answer",
      }),
      {
        placement: "topEnd",
      }
    );
  }
  setItem("savedTimerExam", startedSubtest?.subtestStartedOn);
  setItem("exam", subtestQuestions);
  commonHelper.navigate("/questLayoutExam");
};

export const handleContinueSubtest = async (startedSubtest) => {
  const { getItem } = useStorage();
  const participant = getItem("participant");
  let returnLoadingState = true;

  const resQuest = await client.requestAPI({
    endpoint: `api/v1/exam-participants/${participant?.participantId}/exam-projects/${participant?.projectId}/exam-subtests/${startedSubtest?.subtestId}/questions?isTrial=${startedSubtest?.isTrial}`,
    isAuth: false,
  });

  if (resQuest?.meta?.status === "Success") {
    if (resQuest?.data && resQuest?.data.length === 0) {
      handleFinishNoQuestion(startedSubtest);
      returnLoadingState = false;
    } else {
      getTempAnswer(participant, startedSubtest, resQuest?.data);
    }
  } else {
    commonHelper.toast.push(
      toastACI({
        type: "error",
        header: "Continue Exam Error",
        message: resQuest?.error?.message,
      }),
      {
        placement: "topEnd",
      }
    );
  }
  return returnLoadingState;
};

export const handleFinishSubtest = async (
  locFunction,
  setProcessSubmit,
  setModalSubmit,
  setLoading
) => {
  const { getItem, removeItem } = useStorage();
  const savedQuestion = getItem("savedQuestion");
  const participant = getItem("participant");
  const dataExam = getItem("dataExam");
  const subtest = getItem("subtest");
  let finalChoice = [];

  setProcessSubmit(2);
  setLoading(true);

  for (let i = 0; i < dataExam?.length; i += 1) {
    const choices = dataExam?.[i]?.map((res) => {
      let answer = res?.questionAnswer?.toString();

      if (res?.componentType === 11) {
        answer = JSON.parse(res?.questionAnswer || "[]")?.filter(
          (item2) => item2?.status === "finished"
        );
        answer = answer?.length ? JSON.stringify(answer) : "";
      }
      return {
        questionId: res.questionId,
        questionAnswer: answer,
        questionAnswerVideo: res.questionAnswerVideo,
        questionChoice: res.questionChoice,
        answerTime: res.answerTime,
        questionAnswerScore: res.questionAnswerScore,
        questionAspectId: res.questionAspectId,
        componentTypeId: res.componentType,
      };
    });
    finalChoice = [...finalChoice, ...choices];
  }

  const obj = {
    participantName: participant.participantName,
    participantId: participant.participantId,
    projectId: participant.projectId,
    subtestId: subtest.subtestId,
    isTrial: subtest.isTrial,
    subtestDimensionId: subtest?.subtestDimensionId,
    questions: [...finalChoice],
    questionAccessed: savedQuestion?.questionAccessed || 1,
    locFunction,
  };
  const res = await client.requestAPI({
    endpoint: "api/v1/exam-participants/exam-projects/exam_subtests/submit",
    isAuth: false,
    isSubmit: true,
    method: "POST",
    headers: {
      "X-Encrypted-IP": participant?.ipAddress,
    },
    data: { ...obj },
  });
  if (res?.meta?.status === "Success") {
    setProcessSubmit(3);
    setModalSubmit(false);

    if (getIsLastSubtest()) {
      setLoading(false);
      commonHelper.toast.push(
        toastACI({
          type: "success",
          header: "Exam Info",
          message: "Success submit exam",
        }),
        {
          placement: "topEnd",
        }
      );
      commonHelper.navigate("/finishExam", { replace: true });
    } else {
      setLoading(false);

      removeItem("savedQuestion");
      commonHelper.toast.push(
        toastACI({
          type: "success",
          header: "Exam Info",
          message: "Success submit exam",
        }),
        {
          placement: "topEnd",
        }
      );
    }
  } else {
    setProcessSubmit(1);
    setLoading(false);
    if (res?.error?.message?.includes("finished")) {
      commonHelper.toast.push(
        toastACI({
          type: "success",
          header: "Exam Info",
          message: res?.error?.message || "Success submit exam.",
        }),
        {
          placement: "topEnd",
        }
      );
    } else {
      commonHelper.toast.push(
        toastACI({
          type: "error",
          header: "Exam Info",
          message: res?.error?.message || "Error submit exam.",
        }),
        {
          placement: "topEnd",
        }
      );
    }
  }
  handleStartNextSubtest();
};
